module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/tonybarsotti/Sites/hopkins/~/core-js/modules/_library.js
// module id = 22
// module chunks = 0